import axios from 'axios'
import interceptors from './interceptors'
import router from '@/router'
import { apiPostValidateOtp } from '@/modules/User/services/authentication'

let API_BASE_URL
// for testing purposes
API_BASE_URL = process.env.API_HOST || 'http://localhost:8080/'

export const paramsToString = (p) =>
  p.toString() !== '' ? `?${p.toString()}` : p.toString()

export class HttpClient {
  constructor() {
    this.client = axios.create({ baseURL: API_BASE_URL }) // todo

    interceptors.createRequestInterceptor(this)
    interceptors.createResponseInterceptor(this)
  }
  async handleTokenRenewal (method, url, data, config, resolve) {
    if (sessionStorage.getItem('renewToken') === 'false') {
      sessionStorage.removeItem('mavAuth')
      sessionStorage.setItem('renewToken', 'true')
      const sinisterID = sessionStorage.getItem('sinId')
      const otpCode = sessionStorage.getItem('otpCode')
      const token = await apiPostValidateOtp(sinisterID, otpCode, true)
      if (token) {
        sessionStorage.setItem('mavAuth', `Token ${token.token}`)
      }

      this.client[method](url, data, config || {})
        .then((response) => {
          resolve(response.data)
          sessionStorage.setItem('renewToken', 'false')
        })
    } else {
      setTimeout(() => {
        this.client[method](url, data, config || {})
          .then((response) => {
            resolve(response.data)
          })
      }, 3000)
    }
  }
  request(method, url, data, config) {
    return new Promise((resolve, reject) => {
      this.client[method](url, data, config || {})
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (error) => {
          if (error.response) {
            if (error.response.status === 401) { // refresh token
              await this.handleTokenRenewal(method, url, data, config)
            } else if (error.status === 403) { // expired token
              if (router) {
                router.replace({ name: 'timedout' })
              }
            } else {
              reject(error.response)
            }
          }
        })
    })
  }

  get(url, data, config) {
    return this.request('get', url, data, config)
  }

  post(url, config) {
    return this.request('post', url, config)
  }

  put(url, config) {
    return this.request('put', url, config)
  }

  patch(url, config) {
    return this.request('patch', url, config)
  }

  delete(url, config) {
    return this.request('delete', url, config)
  }

  addHeader(header, method = null) {
    if (!method) {
      this.client.defaults.headers.common[header.name] = header.value
      return
    }
    this.client.defaults.headers[method.toLowerCase()][header.name] =
      header.value
  }

  getHeader(headerName) {
    return this.client.defaults.headers.common[headerName]
  }
}

const httpClient = new HttpClient()

export default httpClient
